import { Configuration } from "@azure/msal-browser";

/**
 * Shared MSAL configuration.
 * Used by both the main taskpane and the login-redirect popup page
 * so they share the exact same cache and auth settings.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || "c0c979a6-2b33-43c9-9e18-edb825a2489f",
    authority:
      process.env.REACT_APP_AUTHORITY ||
      "https://benchlydev.ciamlogin.com/085b6e88-509d-4062-a54c-8b3251e85ba1",
    redirectUri: `${window.location.origin}/login-redirect.html`,
  },
  cache: {
    cacheLocation: "localStorage",
  },
};

/** Scopes requested when acquiring tokens for the Benchly API. */
export const apiScopes = [
  process.env.REACT_APP_API_SCOPE_ACCESS ||
    "api://8387dbe6-c082-4bb5-9d39-67f12715ebdc/access_as_user",
  process.env.REACT_APP_API_SCOPE_READ || "api://8387dbe6-c082-4bb5-9d39-67f12715ebdc/api.read",
  process.env.REACT_APP_API_SCOPE_WRITE || "api://8387dbe6-c082-4bb5-9d39-67f12715ebdc/api.write",
];
